import AJoS from "./components/AJoS";
import "./style.css";

new AJoS();